import { createContext, useContext } from 'react';
import type { PWAState } from '../hooks/usePWA';

export const PWAContext = createContext<PWAState | null>(null);

export function usePWA(): PWAState {
    const ctx = useContext(PWAContext);
    if (!ctx) throw new Error('usePWA must be used inside <PWAProvider>');
    return ctx;
}
